import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconPlayOutlined: React.FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C17.5228 2 22 6.47716 22 12C22 17.5228 17.5228 22 12 22C6.47716 22 2 17.5228 2 12C2 6.47716 6.47716 2 12 2Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0501 12.4669C14.3211 13.2529 12.3371 14.5829 11.3221 15.0099C11.1601 15.0779 10.7471 15.2219 10.6581 15.2239C10.4691 15.2299 10.2871 15.1239 10.1991 14.9539C10.1651 14.8879 10.0651 14.4569 10.0331 14.2649C9.93809 13.6809 9.88909 12.7739 9.89009 11.8619C9.88909 10.9049 9.94209 9.9549 10.0481 9.3769C10.0761 9.2209 10.1581 8.8619 10.1821 8.8039C10.2271 8.6959 10.3091 8.6109 10.4081 8.5579C10.4841 8.5169 10.5711 8.4949 10.6581 8.4979C10.7471 8.4999 11.1091 8.6269 11.2331 8.6759C12.2111 9.0559 14.2801 10.4339 15.0401 11.2439C15.1081 11.3169 15.2951 11.5129 15.3261 11.5529C15.3971 11.6429 15.4321 11.7519 15.4321 11.8619C15.4321 11.9639 15.4011 12.0679 15.3371 12.1549C15.3041 12.1999 15.1131 12.3999 15.0501 12.4669Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default IconPlayOutlined;
